import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MentionConfig } from 'angular-mentions/mention/mention-config';
import { RootConfig } from 'app/client-core/dtos/config.model';
import { ValidationMessage } from 'app/validation';

const $ = jQuery;
@Component({
  selector: 'app-cierant-dynamic-table',
  templateUrl: './cierant-dynamic-table.component.html',
  styleUrls: ['./cierant-dynamic-table.component.scss']
})
export class CierantDynamicTableComponent implements OnInit {
  @Input() mentions: { id: number; name: string; }[] = [
    {
      id: 1,
      name: 'Charles Franca'
    }
  ];
  mentionConfig: MentionConfig = {
    triggerChar: "@",
    labelKey: 'name',
    mentionSelect: (item) => `<${item.email}>`
  }
  summernoteConfig = {
    height: 180,
    toolbar: [
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['view', ['fullscreen']],
    ]
  }

  @Input() rootConfig: RootConfig;
  @Input() tableData: any[] = [];
  @Input() currentPage = 1;
  @Input() loading: boolean;
  @Input() sortOrderAsc = true;
  @Input() sortColumn: number = 1;
  @Input() showLoadMore: boolean;

  @Output() OnSaveMaster = new EventEmitter();
  @Output() OnSaveDetails = new EventEmitter();
  @Output() OnChangeTableOeder = new EventEmitter();
  @Output() OnOpenUpload = new EventEmitter();
  @Output() OnNavigateToLik = new EventEmitter();
  @Output() LoadMoreClicked = new EventEmitter();
  allexpanded: boolean;

  constructor() { }

  ngOnInit() {
  }

  loadMore() {
    this.LoadMoreClicked.emit()
  }

  editingTimeout;
  summerNoteChanged(row, column, index, isMaster) {
    if (this.editingTimeout) {
      clearTimeout(this.editingTimeout);
    }
    this.editingTimeout = setTimeout(() => {
      const value = {
        ...column,
        displayValue: $(`.${isMaster ? 'summernote' : 'summernotedetails'}${index} .note-editable`).html()
      }

      // if (isMaster) {
      //   this.saveMaster(row, value, index);
      // } else {
      //   this.saveDetails(row, index, value);
      // }
    }, 2000);
  }

  getConfig(freeze: boolean) {
    return {
      configuration: {
        master: this.rootConfig.configuration.master.filter(m => m.freeze == freeze),
        details: this.rootConfig.configuration.details.filter(m => m.freeze == freeze)
      }
    }
  }

  enableEditing(row, index) {
    if (!this.tableData[row].hovered[index]) {
      this.tableData[row].hovered[index].editing = true;
    }
  }

  editField(row, index, value) {
    console.log(this.tableData[row][index][0])
    if (this.tableData[row][index][0]) {
      this.tableData[row][index][0].displayValue = value;
    } else {
      this.tableData[row][index][0] = {
        displayValue: value
      };
    }
  }

  navigateToLink(url: string) {
    this.OnNavigateToLik.emit(url);
  }

  saveMaster(row, column, index?) {
    if (Number(index) >= 0 && this.rootConfig.configuration.master[index].format.toLocaleLowerCase() == 'html') {
      column = {
        ...column,
        displayValue: $(`.summernote${index} .note-editable`).html()
      }
    }
    
    this.OnSaveMaster.emit({ row, column });
  }

  saveDetails(row, detailsRow, column, index?) {
    if (this.rootConfig.configuration.details[index].format.toLocaleLowerCase() == 'html') {
      column = {
        ...column,
        displayValue: $(`.summernotedetails${detailsRow} .note-editable`).html()
      }
    }
    
    this.OnSaveDetails.emit({ row, detailsRow, column, index })
  }

  changeTableOrder(column) {
    this.OnChangeTableOeder.emit(column)
  }

  openUpload(row, masterRow) {
    this.OnOpenUpload.emit({ row, masterRow });
  }

  expandAll() {
    this.allexpanded = !this.allexpanded;
    this.tableData = this.tableData.map(t => ({
      ...t,
      opened: !this.allexpanded
    }))
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/cierant-dynamic-table/cierant-dynamic-table.component.ts